import React, { useEffect, useRef, useState, RefObject } from "react";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import WatchableValue from "../models/WatchableValue";
import Page from "../models/Page";
import "./BottomTabs.scss";
import ActivePanes, { WorkingPane } from "../models/ActivePanes";
import Browser from "../browser";
import PaneObject from "../models/PaneObject";
import BaseModel from "../models/BaseModel";
import TabItemData from "../models/TabItemData";
import { showErrToast } from "./Toasts";
import { itx } from "../translationItx/itx";

export async function moveWorkingPaneToScreen2(id: string, subPageId?: string) {
  const obj = state.objectRegistry.getObject(id);
  if (state.activePanes2) {
    state.activePanes2.loadPage(id, subPageId);
    state.activePanes.closePane(id, subPageId);
  } else {
    let toScreen: any | undefined;

    if ((window as any).getScreenDetails) {
      try {
        let granted = true;
        try {
          const options: any = { name: "window-management" }; // cast to any because of non matching typescript definition  // no itx
          const permission = await navigator.permissions.query(options);
          console.log("permission", permission.state);
          if (permission.state !== "denied") {
            // ok go on
            granted = true;
          } else {
            return null;
          }
        } catch (ex) {
          console.log(ex);
          // Nothing.
        }
        if (granted) {
          console.log("getScreenDetails");

          const screenDetailsPromise = (window as any).getScreenDetails();
          const screenDetails = await screenDetailsPromise;
          console.log("getScreenDetails done ", screenDetails);

          if (screenDetails.screens.length > 1) {
            if (screenDetails.currentScreen == screenDetails.screens[1]) {
              toScreen = screenDetails.screens[0];
            } else if (screenDetails.currentScreen == screenDetails.screens[0]) {
              toScreen = screenDetails.screens[1];
            }
          }
        }
      } catch (ex: any) {
        showErrToast(ex.msg);
      }
    }

    ///////////////////////////////////////////////////

    (window as any).newWindowArgs = {
      device: obj,
      subPageId: subPageId,
    };

    let popupOptions = "popup=true, scrollbars=no, status=no, menubar=no, toolbar=no, location=no "; // no itx

    if (toScreen) {
      popupOptions += "width=" + toScreen.width + ", height=" + toScreen.height; // no itx
      popupOptions += ", top=" + toScreen.top + ", left=" + toScreen.left; // no itx
    }

    const w = window.open(`${window.location.origin}/screen2`, "Sceen2Popup", popupOptions); // no itx
    if (!w) {
      alert(itx("menuBar.openScreen2Failed", "Open Screen2 failed, Are Popups disabled ????"));
    } else {
      state.activePanes.closePane(id, subPageId);
      w.focus();

      (window as any).secondScreenWindow = w;

      // if (toScreen) {
      //   console.log("Move to Screen 2", toScreen)
      //   setTimeout(() => {
      //     //            w.moveTo(toScreen.left, toScreen.top)
      //     //            w.resizeTo(toScreen.width, toScreen.height)
      //   }, 100)
      // }
    }
  }
}

function BottomTab(props: {
  data: TabItemData;
  useAsTabStrip: boolean;
  index: number;
  onActivate: (index: number, id: string, subPageId: string | undefined) => void;
  onClose?: (index: number, id: string, subPageId: string | undefined) => void;
  colorSelected?: string;
  colorDeselected?: string;
  pane?: WorkingPane;
  styleContent?: any;
  moveToScreen?: number;
}) {
  const { data, index, onActivate, onClose, colorSelected, colorDeselected, pane, styleContent, moveToScreen } = props;
  const id = data.paneId;

  useOnChangeWatcher(pane?.item, (changedProperty, changedObject) => {
    if (pane?.item?.className == "Page" && (changedProperty == "name" || changedProperty == "tag")) {
      return true;
    }
    return false;
  });

  useOnChangeWatcher(data);

  function getPaneTag() {
    if (pane) {
      let paneTag = pane.tag;
      // can`t translate in initialisation because there is the state not defined
      if (pane.item instanceof BaseModel && !(pane.item as BaseModel)?.treeViewModel?.getTagNeeded()) {
        paneTag = "";
      }
      if ((pane.item as PaneObject)?.type == "help") {
        paneTag = state.translate("menuBar.help", "help");
      }

      return paneTag;
    } else {
      return data.title;
    }
  }

  async function doMoveToScreen2() {
    const obj = state.objectRegistry.getObject(id);
    if (state.activePanes2) {
      state.activePanes2.loadPage(id);
      state.activePanes.closePane(id);
    } else {
      let toScreen: any | undefined;

      if ((window as any).getScreenDetails) {
        try {
          let granted = true;
          try {
            const permission = await (navigator.permissions as any).query({ name: "window-management" }); // no itx
            console.log("permission", permission.state);
            if (permission.state !== "denied") {
              // ok go on
              granted = true;
            } else {
              return null;
            }
          } catch (ex) {
            console.log(ex);
            // Nothing.
          }
          if (granted) {
            console.log("getScreenDetails");

            const screenDetailsPromise = (window as any).getScreenDetails();
            const screenDetails = await screenDetailsPromise;
            console.log("getScreenDetails done ", screenDetails);

            if (screenDetails.screens.length > 1) {
              if (screenDetails.currentScreen == screenDetails.screens[1]) {
                toScreen = screenDetails.screens[0];
              } else if (screenDetails.currentScreen == screenDetails.screens[0]) {
                toScreen = screenDetails.screens[1];
              }
            }
          }
        } catch (ex: any) {
          showErrToast(ex.msg);
        }
      }

      ///////////////////////////////////////////////////

      (window as any).newWindowArgs = {
        device: obj,
      };

      let popupOptions = "popup=true, scrollbars=no, status=no, menubar=no, toolbar=no, location=no "; // no itx

      if (toScreen) {
        popupOptions += "width=" + toScreen.width + ", height=" + toScreen.height; // no itx
        popupOptions += ", top=" + toScreen.top + ", left=" + toScreen.left; // no itx
      }

      const w = window.open(`${window.location.origin}/screen2`, "Sceen2Popup", popupOptions); // no itx
      if (!w) {
        alert(itx("menuBar.openScreen2Failed", "Open Screen2 failed, Are Popups disabled ????"));
      } else {
        state.activePanes.closePane(id);
        w.focus();

        // if (toScreen) {
        //   console.log("Move to Screen 2", toScreen)
        //   setTimeout(() => {
        //     //            w.moveTo(toScreen.left, toScreen.top)
        //     //            w.resizeTo(toScreen.width, toScreen.height)
        //   }, 100)
        // }
      }
    }
  }

  return (
    <div
      data-testid={`tab_${data.title}`}
      className={`BottomTab ${data.active ? "active" : ""}  ${data.open ? "open" : ""}  ${data.obj?.isTransitOpen ? "transit-open" : ""} `}
      id={data.id + "_tab"} // no itx
      key={data.id + "_tab"} // no itx
      style={{
        ...styleContent,
      }}
    >
      <div
        className="BottomTabTitle"
        onClick={(event) => {
          event.stopPropagation();
          data.open = true;

          if (onActivate) {
            onActivate(index, id, data.subPageId);
          }
        }}
      >
        {!data.title && (
          <div
            style={{
              position: "relative",
              display: "inline-block",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              flexShrink: "0",
            }}
          >
            {getPaneTag()}
          </div>
        )}

        {!data.title && pane?.name && (
          <div
            style={{
              position: "relative",
              display: "inline-block",
              whiteSpace: "nowrap",
              paddingLeft: "10px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              maxWidth: "200px",
              flexShrink: "2",
            }}
          >
            {pane?.name}
          </div>
        )}

        {data.title && (
          <div
            style={{
              position: "relative",
              display: "inline-block",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              maxWidth: "300px",
              flexShrink: "2",
            }}
          >
            {data.title}
          </div>
        )}
      </div>

      {onClose && state.settings.secondScreenSupport && moveToScreen == 2 && (
        <div
          onClick={() => moveWorkingPaneToScreen2(id, data.obj?.subPageId)}
          style={{
            marginLeft: "10px",
            width: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "1.5em",
          }}
        >
          <i className="las la-caret-square-right"></i>
        </div>
      )}

      {onClose && moveToScreen == 1 && (
        <div
          onClick={() => {
            const obj = state.objectRegistry.getObject(id);
            if (state.activePanes2) {
              state.activePanes2.closePane(id, data.subPageId);
              const obj = state.objectRegistry.getObject(id);
              if (obj) {
                state.activePanes.openPane(obj as BaseModel, data.subPageId);
              }
            }
          }}
          style={{ marginLeft: "10px", width: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          <i className="las la-caret-square-left"></i>
        </div>
      )}

      {onClose && (
        <div
          onClick={() => {
            if (onClose) {
              onClose(index, id, data.subPageId);
            }
          }}
          style={{ paddingLeft: "10px" }}
        >
          &#x2715;
        </div>
      )}
    </div>
  );
}
export function BottomTabsWrapper(props: {
  items: Array<TabItemData>;
  active: number;
  onActivate: (index: number, id: string, subPageId: string | undefined) => void;
  onClose?: (index: number, id: string, subPageId: string | undefined) => void;
  watchIndex?: WatchableValue<number>;
  colorSelected?: string;
  colorDeselected?: string;
  activePanes?: ActivePanes;
  moveToScreen?: number;
}) {
  const { watchIndex, active, colorSelected, colorDeselected, activePanes, moveToScreen } = props;
  const { items, onActivate, onClose } = props;
  const [showArrows, setShowArrows] = useState<boolean>(false);
  const [widthString, setWidthString] = useState<string>("100%");
  const [bottomTabsWrapperWidth, setBottomTabsWrapperWidth] = useState<string>("100%");

  const [activeItemIndex, setActiveItemIndex] = useState(active);

  useOnChangeWatcher(state.contextMenuManager);
  useOnChangeWatcher(activePanes);

  const lastItemCount = useRef<number>(items.length);

  useEffect(() => {
    if (lastItemCount.current != items.length) {
      lastItemCount.current = items.length;
      handleResize();

      // todo: scrollTo active item !!! mwe 30.10.2023
    }
  });

  function updateScrollPosition(index: number) {
    // mwe 6.2.2024
    //  Diese funktion führt dazu das der Bildschiminhalt sich teilwiese um einige pixel nach oben veschiebt.
    //  Daher erst mal auskommentiert.
    //  Der vermutliche Grund ist, dass die tabs etwas "zu hoch sind" und bei ScrollIntoView "hoch geschoben werden"
    // Das ist aber bislang unbestätigt
    //
    // if (lastActiveItemIndex.current != index) {
    //   setTimeout(() => {
    //     lastActiveItemIndex.current = index;
    //     const item = items[index];
    //     if (item) {
    //       const elm = document.getElementById(`${item.id}_tab`);
    //       elm?.scrollIntoView({
    //         behavior: "smooth",
    //         block: "start",
    //         inline: "nearest",
    //       });
    //     }
    //   }, 100);
    // }
  }

  if (watchIndex) {
    useOnChangeWatcher(watchIndex, () => {
      const i: number = watchIndex.value;
      handleResize();
      setActiveItemIndex(i);
      updateScrollPosition(i);
      return false;
    });
  }

  const scrollElm = useRef<HTMLDivElement>(null);
  const scrollTimer = useRef<any>(undefined);

  function handleResize() {
    function checkIfOverflow(widthPx: number): boolean {
      const workingPaneElement = document.getElementById("BottomTabs");
      if (workingPaneElement) {
        return workingPaneElement.scrollWidth > workingPaneElement.clientWidth;
      }
      let tabsLength = 0;
      items.forEach((item) => {
        const itemelm = document.getElementById(item.id + "_tab");
        if (itemelm) {
          tabsLength = tabsLength + itemelm.offsetWidth;
        }
      });
      if (tabsLength > widthPx) {
        return true;
      }
      return false;
    }

    const parent = document.getElementById("WorkingPanes");
    if (parent && activePanes) {
      let w = parent.offsetWidth - getOcoupiedFrameWith(activePanes);

      // let widthPxBack = `calc(100% - ${getOcoupiedFrameWith})`;

      // if (!Browser.isMobile() || Browser.isLandScape()) {
      //   if (state.activePanes.isPdfOpen()) {
      //     widthPxBack = "calc(100% - 300px)";
      //     w -= 300;
      //   } else if (state.activePanes.isDrawingOpen()) {
      //     widthPxBack = "calc(100% - 240px)";
      //     w -= 240;
      //   }
      // }

      // const xshowArrowsBack = checkIfOverflow(w);
      // setShowArrows(xshowArrowsBack);
      setWidthString(`100%`);
      ocupiedFraneSetBottomTabsWidth(activePanes);
    }
  }

  useEffect(() => {
    const handleResizeEvent = () => {
      handleResize();
    };
    window.addEventListener("resize", handleResizeEvent);
    return () => window.removeEventListener("resize", handleResizeEvent);
  }, []);

  useEffect(() => {
    handleResize();
  }, []);

  useEffect(() => {
    handleResize();
  }, [widthString]);

  function ArrowButton(props: { direction: string }) {
    const { direction } = props;
    return (
      <i
        className={`las la-angle-${direction} arrows`}
        onMouseUp={() => {
          clearInterval(scrollTimer.current);
          scrollTimer.current = 0;
        }}
        onMouseDown={() => {
          scrollTimer.current = setInterval(() => {
            if (scrollElm?.current) {
              let step = 20;
              if (direction == "left") {
                step = -20;
              }
              scrollElm.current.scrollLeft = scrollElm.current.scrollLeft + step;
            }
          }, 50);
        }}
      />
    );
  }
  function getOcoupiedFrameWith(activePanes: ActivePanes): number {
    let res = 0;
    const cabinetPageControl = document.getElementById("cabinetPageControl");
    const pageControlElem = cabinetPageControl || document.getElementById("pageControl");
    const drawingIsOpen = activePanes.isDrawingOpen();
    const sheetNumberShown = activePanes.isListOpen();
    const pdfShown = activePanes.isPdfOpen();

    if (pageControlElem && (cabinetPageControl || drawingIsOpen || sheetNumberShown || pdfShown)) {
      res = pageControlElem.offsetWidth;
    }
    return res;
  }

  async function ocupiedFraneSetBottomTabsWidth(activePanes: ActivePanes) {
    // set Timer to get the right view
    setTimeout(() => {
      setBottomTabsWrapperWidth(`calc(100% - ${getOcoupiedFrameWith(activePanes) + 25}px)`);
    }, 100);
  }

  return (
    <div
      className="BottomTabsWrapper"
      id="BottomTabsWrapper"
      style={{
        width: Browser.isMobile() ? undefined : bottomTabsWrapperWidth,
        pointerEvents: "auto",
      }}
    >
      {showArrows && (
        <ArrowButton
          direction="left" // no itx
        />
      )}
      <BottomTabs // no itx
        items={items}
        activeItemIndex={activeItemIndex}
        onActivate={(index, id, subPageId) => {
          setActiveItemIndex(index);
          handleResize();
          updateScrollPosition(index);
          onActivate(index, id, subPageId);
        }}
        onClose={onClose}
        colorSelected={colorSelected}
        colorDeselected={colorDeselected}
        widthString={widthString}
        scrollElm={scrollElm}
        moveToScreen={moveToScreen}
        useAsTabStrip={false}
      />
      <div
        style={{
          position: "absolute",
          right: "0px",
          top: "0px",
          width: "15px",
          marginTop: "4px",
          height: "100%",
          background: "linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 100%)",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "0px",
          top: "5px",
          width: "10px",
          height: "100%",
          background: "linear-gradient(270deg, rgba(0,0,0,0) 0%, rgba(255,255,255,1) 80%)",
        }}
      ></div>
      {showArrows && <ArrowButton direction="right" />},
    </div>
  );
}

export function BottomTabs(props: {
  items: Array<TabItemData>;
  activeItemIndex: number;
  onActivate: (index: number, id: string, subPageId) => void;
  onClose?: (index: number, id: string, subPageId) => void;
  colorSelected?: string;
  colorDeselected?: string;
  widthString?: string;
  scrollElm?: RefObject<HTMLDivElement>;
  styleContent?: any;
  moveToScreen?: number;
  useAsTabStrip: boolean;
}) {
  const { activeItemIndex, colorSelected, colorDeselected, widthString, styleContent, moveToScreen, useAsTabStrip } =
    props;

  const { items, onActivate, onClose, scrollElm } = props;

  const tabElements: any = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    let color: string | undefined;
    if (item.color) {
      if (typeof item.color == "string") {
        color = item.color;
      } else {
        color = item.color(item);
      }
    }

    tabElements.push(
      <BottomTab
        key={item.id}
        data={item}
        colorSelected={colorSelected}
        colorDeselected={colorDeselected}
        index={i}
        useAsTabStrip={useAsTabStrip}
        onActivate={(index, id) => {
          if (!useAsTabStrip) {
            //
            // if is already active
            //   select object

            if (activeItemIndex >= 0) {
              items[activeItemIndex].raiseOnChange("open");
            }

            if (true || activeItemIndex == index) {
              if (item.obj) {
                let selected: undefined | BaseModel = undefined;
                if (item.obj.item?.className == "Page") {
                  selected = (item.obj.item as Page).getPageSelectionElement();
                }
                if (!selected) {
                  if (item.obj.item?.isBaseModel) {
                    if (item.obj.item.className != "PaneObject") {
                      state.selectionManager.selectedObject = item.obj.item as BaseModel;
                      state.selectionManager.scrollSelectedObjectIntoView();
                    }
                  }
                } else {
                  state.selectionManager.selectedObject = selected;
                  state.selectionManager.scrollSelectedObjectIntoView();
                }
              }
            }
          }

          if (onActivate) {
            onActivate(index, id, item.subPageId);
          }
        }}
        onClose={item.closeable ? onClose : undefined}
        pane={item.obj}
        styleContent={{ ...styleContent, color: color }}
        moveToScreen={moveToScreen}
      />,
    );
  }
  return (
    <div
      ref={scrollElm}
      className="BottomTabs scrollableHidden"
      id="BottomTabs"
      style={{
        flexShrink: "0",
        width: widthString || "100%",
      }}
    >
      <div className="BottomTabsContainer">
        <div style={{ width: "20px", flexShrink: "0" }}>&nbsp; </div>
        {tabElements}
      </div>
    </div>
  );
}
